<template>
    <div v-if="hasFieldToDisplay()">
        <div class="tabulation-title">
            <h5>
                <v-icon class="blue--text text--darken-2">label</v-icon> Informations spécifiques
            </h5>
        </div>

        <div class="form-container mr-auto ml-auto mt-5">
            <div v-for="familyElement in families">
                <v-expansion-panels class="mb-5" v-if="getField(familyElement.name) !== undefined &&
                getField(familyElement.name).title !== null">
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            <b style="color: #697db5">{{ getField(familyElement.name).title }}</b>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div v-html="getField(familyElement.name).description"></div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

                <v-autocomplete v-if="hasFamilyElement(familyElement.name) &&
                (providerFamilies[familyElement.name].length > 0 || !getField(familyElement.name).skipped)"
                                :items="getFamilyByCode(familyElement.name)"
                                chips
                                @change="updateOrDeleteElement($event, familyElement.name)"
                                :value="providerFamilies[familyElement.name]"
                                deletable-chips
                                :label="familyElement.label"
                                item-text="label"
                                return-object
                                :multiple="!familyElement.multiplicity" outlined>
                </v-autocomplete>

                <v-autocomplete v-if="hasFamilyElement(familyElement.name) &&
                providerFamilies[familyElement.name].length === 0 && getField(familyElement.name).skipped"
                                :items="['Non concerné']"
                                chips
                                :label="familyElement.label"
                                :value="'Non concerné'"
                                outlined>
                </v-autocomplete>

                <div v-if="getField(familyElement.name) !== undefined &&
                getField(familyElement.name).title !== null" style="height: 40px"></div>
            </div>

          <div v-if="hasField('CHIEF')">
            <v-text-field style="padding-top: 0 !important;" v-model="chef" @change="updateChef" outlined label="Chef">
            </v-text-field>
          </div>

            <div v-if="hasField('DATE_CLASSEMENT_HLO') &&
            (hloRankingDate !== null || !getField('DATE_CLASSEMENT_HLO').skipped)">
                <v-text-field readonly style="padding-top: 0 !important;" v-model="hloRankingDate" label="Classement Atout France"
                    @click="showPicker = true" outlined>
                </v-text-field>
            </div>

            <div v-else-if="hasField('DATE_CLASSEMENT_HLO') && hloRankingDate === null &&
            getField('DATE_CLASSEMENT_HLO').skipped">
                <v-text-field readonly style="padding-top: 0 !important;" value="Non concerné" outlined label="Classement Atout France">
                </v-text-field>
            </div>

          <div v-if="hasField('COMPLEMENT_ACCUEIL')">
            <v-textarea  class="textarea" :value="complementAccueil" @change="updateComplementAccueil" outlined
            label="Complément accueil">
            </v-textarea>
          </div>

            <div v-if="hasField('CITQ_NUMBER')">
                <v-text-field  class="textarea" :value="citqNumber" @change="updateCitqNumber" outlined
                label="Numéro CITQ">
                </v-text-field>
            </div>

            <div v-if="hasField('ACCEPTED_ANIMALS')" style="margin-bottom: 30px">
                <label>Animaux acceptés</label>
                <v-radio-group row class="mt-auto mb-auto" :value="acceptedAnimals"
                    @change="updateBooleanElement([$event, 'ACCEPTED_ANIMALS'])" style="padding-top: 0 !important;">
                    <v-radio label="Oui" class="text" :value="true"></v-radio>
                    <v-radio label="Non" class="text" :value="false"></v-radio>
                    <v-radio label="Non communiqué" class="text" value="null"></v-radio>
                </v-radio-group>
            </div>

        </div>

        <v-dialog ref="dialog" v-model="showPicker" width="290px">
            <v-date-picker locale="fr-FR" color="primary" v-model="selectedDate" @input="setDatePicker"
                :first-day-of-week="1">
                <v-spacer></v-spacer>
            </v-date-picker>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex"

export default {
    name: "Specific",
    data() {
        return {
            providerFamilies: {},
            familyToEscape: ['OfferType', 'Capacites'],
            families: [],
            acceptedAnimals: null,
            showPicker: false,
            selectedDate: null,
            hloRankingDate: null,
        }
    },
    methods: {
        ...mapMutations('web_form', [
            'addElement', 'removeElement', 'updateBooleanElement', 'pushBooleanElement'
        ]),
        hasFieldToDisplay() {
            let has = false

            this.families.forEach(family => {
                if (this.hasFamilyElement(family.name)) {
                    has = true
                }
            })

            if (this.hasField('COMPLEMENT_ACCUEIL')) {
                has = true
            }

            if (this.hasField("ACCEPTED_ANIMALS")) {
                has = true
            }

            if (this.hasField("CITQ_NUMBER")) {
                has = true
            }

            return has
        },
        updateOrDeleteElement(newElements, property) {
            let currentElements = this.providerFamilies[property]

            if (currentElements.length > newElements.length) {  // Cas suppression
                this.deleteElement(currentElements, newElements)
            } else { // Cas Ajout
                this.addNewElement(currentElements, newElements)
            }

            this.providerFamilies[property] = newElements
        },
        addNewElement(currentElements, newElements) {
            let element = newElements
            const previousValue = JSON.parse(JSON.stringify(currentElements))

            if (Array.isArray(newElements)) {
                let diff = newElements.filter(_element => !previousValue.includes(_element)) || []

                if (diff.length) {
                    element = diff[diff.length - 1]
                }
            } else if (previousValue) {
                this.removeElement(previousValue)
            }

            this.addElement(element)
        },
        deleteElement(currentElements, newElements) {
            const previousValue = JSON.parse(JSON.stringify(currentElements))

            const diff = previousValue.filter(element => {
                return !newElements.map(elt => elt.id).includes(element.id)
            }) || []

            let element = newElements

            if (diff.length) {
                element = diff[diff.length - 1]
            }

            this.removeElement(element)
        },
        setHloRankingDate() {
            if (this.provider.date_fields !== undefined && this.provider.date_fields.length) {
                this.provider.date_fields.forEach(field => {
                    if (field.code === 'DATE_CLASSEMENT_HLO') {
                        this.hloRankingDate = this.formatDate(field.value, false)
                    }
                })
            }
        },
        setDatePicker(value) {
            this.hloRankingDate = this.formatDate(value, false)

            this.provider.date_fields.forEach(field => {
                if (field.code === 'DATE_CLASSEMENT_HLO') {
                    field.value = this.formatDate(value, false)
                }
            })
        },
      updateComplementAccueil(value) {
        this.provider.contents.forEach(content => {
          if (content.language.code === 'fr') {
            content.complement_accueil = value
          }
        })
      },
      updateChef(value) {
        this.provider.contents.forEach(content => {
          if (content.language.code === 'fr') {
            content.chef = value
          }
        })
      },
        updateCitqNumber(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.citq_number = value
                }
            })
        },
    },
    computed: {
        ...mapState('web_form', ['provider', 'disabled', 'familyElements', 'categoryFamilies']),
        ...mapGetters('web_form', ['hasField', 'hasFamilyElement', 'getFamilyByCode', 'getElementsByFamilyCode', 'getField']),
      complementAccueil() {
        let _content = {}

        this.provider.contents.forEach(content => {
          if (content.language.code === 'fr') {
            _content = content
          }
        })

        return _content.complement_accueil
      },
      chef() {
        let _content = {}

        this.provider.contents.forEach(content => {
          if (content.language.code === 'fr') {
            _content = content
          }
        })

        return _content.chef
      },
        citqNumber() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if(content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.citq_number
        },
    },
    created() {
        this.acceptedAnimals = String(null)

        this.families = this.categoryFamilies.filter(family => !this.familyToEscape.includes(family.name))

        this.families.forEach(family => {
            this.$set(this.providerFamilies, family.name, this.getElementsByFamilyCode(family.name, family.multiplicity))
        })

        this.setHloRankingDate()

        if (this.provider.boolean_elements !== null && this.provider.boolean_elements !== undefined) {
            let foundAcceptedAnimals = false

            this.provider.boolean_elements.forEach(booleanElement => {
                if (booleanElement.attribute.code === 'ACCEPTED_ANIMALS') {
                    this.acceptedAnimals = booleanElement.value ?? String(booleanElement.value)

                    foundAcceptedAnimals = true
                }
            })

            if (!foundAcceptedAnimals) {
                let booleanElement = {
                    attribute: {
                        code: 'ACCEPTED_ANIMALS'
                    },
                    value: "null"
                }
                this.pushBooleanElement(booleanElement)
            }
        }
    }
}
</script>